'use client';

import { useTranslations } from 'next-intl';
import React, { useRef } from 'react';

import PremiereSectionItem from '@/app/[locale]/[domain]/(default-layout)/_components/home-section-two/PremiereSectionItem';
import SectionTitle from '@/app/[locale]/[domain]/(default-layout)/_components/SectionTitle';

import { styleFaded } from '@cineamo/ui/src/helpers/style-helper';

import { CachedContentData } from '@/hooks/useCachedContentData';
import useScrollState from '@cineamo/ui/src/hooks/useScrollState';

import BackAndForthButtonOverlay from '@cineamo/ui/src/button/BackAndForthButtonOverlay';

import CenterLayout from '@cineamo/composables/src/CenterLayout';

type PremieresTabPanelProps = {
    premieres: CachedContentData[];
};

const PremieresTabPanel: React.FC<PremieresTabPanelProps> = ({ premieres }) => {
    const eventsScrollContainerRef = useRef(null);
    const t = useTranslations();

    const { styleFadedState } = useScrollState({
        scrollContainerRef: eventsScrollContainerRef,
        initialState: {
            startReached: true,
            endReached: false
        }
    });

    return (
        <CenterLayout className="space-y-12 lg:space-y-16">
            <SectionTitle title={t('home.premieres')} />
            <div className="relative flex flex-row">
                <div
                    className="relative w-full flex flex-row space-x-16 overflow-x-auto no-scrollbar"
                    style={styleFaded(styleFadedState, 5)}
                    ref={eventsScrollContainerRef}>
                    {premieres.map((content) => (
                        <PremiereSectionItem
                            key={`PremiereSectionItem#${content.id}`}
                            content={content}
                        />
                    ))}
                </div>
                {premieres.length > 0 && (
                    <BackAndForthButtonOverlay
                        scrollContainerRef={eventsScrollContainerRef}
                        renderOutside
                    />
                )}
            </div>
        </CenterLayout>
    );
};

export default PremieresTabPanel;
